'use client'

import { useContext } from 'react'

import { FormContext } from '/react4xp/components/prototype/Form/Form'

interface UseFormFieldProps {
	name?: string
	type?: string
	externalError?: string
	externalInvalid?: boolean
	required?: boolean
	requiredMessage?: string
	invalidEmailMessage?: string
}

export const useFormField = ({
	name,
	type,
	externalError,
	externalInvalid,
	required,
	requiredMessage,
	invalidEmailMessage,
}: UseFormFieldProps) => {
	const formContext = useContext(FormContext)

	const formError = name && formContext ? (formContext.form.formState.errors[name]?.message as string) : null
	const formInvalid = name && formContext ? !!formContext.form.formState.errors[name] : false

	const finalError = externalError || formError
	const finalInvalid = externalInvalid !== undefined ? externalInvalid : !!finalError || formInvalid

	const updateFormValue = (value: string, options?: { shouldValidate?: boolean }) => {
		if (name && formContext) {
			formContext.form.setValue(name, value, { shouldValidate: options?.shouldValidate ?? true })
		}
	}

	const getRegisterProps = (validationRules?: Record<string, unknown>) => {
		if (!formContext || !name) return {}

		return formContext.form.register(name, {
			required: required && (requiredMessage ?? 'Dette feltet er påkrevd'),
			...(type === 'email' && {
				pattern: {
					value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
					message: invalidEmailMessage ?? 'Ugyldig e-postadresse',
				},
			}),
			...validationRules,
		})
	}

	return {
		formContext,
		finalError,
		finalInvalid,
		updateFormValue,
		getRegisterProps,
	}
}
